export interface ActionType {
  type: ACTION_TYPES | string
  /** Many legacy actions omit `payload` and use free-form fields instead. */
  payload?: unknown
  [key: string]: unknown
}

export enum ACTION_TYPES {
  APP_LOAD_INITIAL_DATA = 'load_initial_data',
  CLOSE_FREE_CARD = 'close_free_card',
  CLOSE_REMOVE_CARD = 'close_remove_card',
  CLOSE_WELCOME_CARD = 'close_welcome_card',
  OPEN_CHANGE_THEME = 'open_change_theme',
  TOAST = 'TOAST',
}
